// extracted by mini-css-extract-plugin
module.exports = {"cp-swiper":"Swiper_cp-swiper__3kHIr","less":"Swiper_less__3AEc1","multi":"Swiper_multi__1M-Fb","list":"Swiper_list__1DPmN"};